import ApiService from '../../../../../services/ApiService'
import InstitutionInactive from '../../../Institutions/components/institutionInactive/institutionInactive.vue'

export default {
  components: {
    InstitutionInactive,
  },

  props: {
    title: String,
    unidade: Object,
  },

  created() {
    this.getInstitutions()
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    const institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = institution.id
    this.institutionInactive = institution.status == 1

    if (this.unidade) {
      this.currentUnidade = this.unidade
      this.isEditing = true
    }
  },

  data: () => ({
    loading: false,
    step: 0,
    firstValid: true,
    secondValid: true,
    thirdValid: true,
    error: false,
    errorMessage: '',
    isEditing: false,
    institutionInactive: false,
    institutionId: null,
    institutions: [],
    userLogged: {},
    currentUnidade: {
      hasAcess: false,
      name: '',
      initials: '',
      cnpj: '',
      phone: '',
      address: '',
      district: '',
      locationNumber: '',
      complement: '',
      city: '',
      state: '',
      emailResponsibleToQual: '',
      emailResponsibleToLeave: '',
      serviceTimeEquipmentLowCriticality: '00:00',
      resolutionTimeEquipmentLowCriticality: '000',
      serviceTimeEquipmentMediumCriticality: '00:00',
      resolutionTimeEquipmentMediumCriticality: '000',
      serviceTimeEquipmentHighCriticality: '00:00',
      resolutionTimeEquipmentHighCriticality: '000',
      contacts: [],
    },
    nameRules: [
      (v) => !!v || 'Nome requerido',
      (v) => (v && v.length <= 128) || 'Nome deve ter no máximo 128 caracteres',
    ],
    initialsRules: [
      (v) => !!v || 'Sigla requerida',
      (v) => (v && v.length <= 4) || 'Sigla deve ter no máximo 4 caracteres',
    ],
    phoneRules: [(v) => !!v || 'Telefone requerido'],
    addressRules: [
      (v) => !!v || 'Logradouro requerido',
      (v) => v.length <= 64 || 'Logradouro deve ter no máximo 64 caracteres',
    ],
    districtRules: [
      (v) => !!v || 'Bairro requerido',
      (v) => v.length <= 32 || 'Bairro deve ter no máximo 32 caracteres',
    ],
    complementRules: [
      (v) => v.length <= 64 || 'Complemento deve ter no máximo 64 caracteres',
    ],
    cityRules: [
      (v) => !!v || 'Cidade requerido',
      (v) => v.length <= 32 || 'Cidade deve ter no máximo 32 caracteres',
    ],
    stateRules: [
      (v) => !!v || 'Estado requerido',
      (v) => v.length <= 2 || 'Estado deve ter no máximo 2 caracteres',
    ],
    serviceTimeRules: [
      (v) => /^\d\d:\d\d/.test(v) || 'Horário em formato inválido',
    ],
    emailRules: [(v) => /.+@.+\..+/.test(v) || 'E-mail inválido'],
    apiService: new ApiService(),
  }),

  computed: {
    currentTitle() {
      switch (this.step) {
        case 0:
          return 'Informações Iniciais'
        case 1:
          return 'Localização'
        default:
          return this.isEditing ? 'Atualização efetuada' : 'Cadastro efetuado'
      }
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return 'Continuar'
        case 1:
          return this.isEditing ? 'Atualizar' : 'Cadastrar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    addContact() {
      this.currentUnidade.contacts.push({})
    },

    removeContact(index) {
      this.currentUnidade.contacts.splice(index, 1)
    },

    uppercase() {
      this.currentUnidade.initials = this.currentUnidade.initials.toUpperCase()
      this.currentUnidade.state = this.currentUnidade.state.toUpperCase()
    },

    close() {
      this.$emit('close')
    },

    validarCNPJ(cnpj) {
      cnpj = cnpj.replace(/[^\d]+/g, '')

      if (cnpj == '') return false

      if (cnpj.length != 14) return false

      // Elimina CNPJs invalidos conhecidos
      if (
        cnpj == '00000000000000' ||
        cnpj == '11111111111111' ||
        cnpj == '22222222222222' ||
        cnpj == '33333333333333' ||
        cnpj == '44444444444444' ||
        cnpj == '55555555555555' ||
        cnpj == '66666666666666' ||
        cnpj == '77777777777777' ||
        cnpj == '88888888888888' ||
        cnpj == '99999999999999'
      )
        return false

      // Valida DVs
      let tamanho = cnpj.length - 2
      let numeros = cnpj.substring(0, tamanho)
      let digitos = cnpj.substring(tamanho)
      let soma = 0
      let pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) pos = 9
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
      if (resultado != digitos.charAt(0)) return false

      tamanho = tamanho + 1
      numeros = cnpj.substring(0, tamanho)
      soma = 0
      pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) pos = 9
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
      if (resultado != digitos.charAt(1)) return false

      return true
    },

    async getInstitutions() {
      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
      })
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          this.step += 1
        }
      } else if (this.step === 1) {
        if (this.$refs.secondForm.validate()) {
          await this.submit()
        }
      } else {
        this.close()
      }
    },

    back() {
      this.step -= 1
    },

    maskPhone() {
      if (!!this.currentUnidade.phone) {
        return this.currentUnidade.phone.length === 13
          ? '(##) ####-####'
          : '(##) #####-####'
      }
    },

    async submit() {
      this.loading = true

      const unidade = {
        Id: this.currentUnidade.id,
        InstitutionId: this.institutionId,
        Name: this.currentUnidade.name,
        Initials: this.currentUnidade.initials,
        Cnpj: this.currentUnidade.cnpj,
        Phone: this.currentUnidade.phone,
        Address: this.currentUnidade.address,
        District: this.currentUnidade.district,
        LocationNumber: this.currentUnidade.locationNumber,
        Complement: this.currentUnidade.complement,
        City: this.currentUnidade.city,
        State: this.currentUnidade.state,
        EmailResponsibleToQual: this.currentUnidade.emailResponsibleToQual,
        EmailResponsibleToLeave: this.currentUnidade.emailResponsibleToLeave,
        contacts: this.currentUnidade.contacts,
      }

      let url = 'unidade/add'

      if (this.isEditing) {
        url = 'unidade/edit'
      } else {
        unidade.HasAcess = this.currentUnidade.hasAcess
      }

      await this.apiService
        .post(url, unidade)
        .then(() => {
          this.loading = false
          this.step += 1
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          this.loading = false

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },
  },
}
